module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper pt-header65"
  }, [_c('header', {
    staticClass: "gheader -white gheader-fix"
  }, [_c('div', {
    staticClass: "hedder_wrap"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("戻る")])])])]), _c('div', {
    staticClass: "safety-confirmation-container"
  }, [(_vm.isExist && _vm.isTraining) ? _c('div', {
    staticClass: "safety-confirmation-header"
  }, [_c('p', [_vm._v("こちらは訓練です")])]) : _vm._e(), _c('div', {
    staticClass: "wifi-section"
  }), _c('div', {
    staticClass: "safety-confirmation-content"
  }, [_c('div', {
    staticClass: "safety-confirmation-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isSafety),
      expression: "isSafety"
    }],
    attrs: {
      "type": "checkbox",
      "id": "isSafety",
      "name": "isSafety"
    },
    domProps: {
      "checked": Array.isArray(_vm.isSafety) ? _vm._i(_vm.isSafety, null) > -1 : (_vm.isSafety)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isSafety,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isSafety = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isSafety = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isSafety = $$c
        }
      }
    }
  }), _c('label', {
    attrs: {
      "for": "isSafety"
    }
  }, [_vm._v("家族全員無事です")])]), _c('div', {
    staticClass: "can-go-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.canHelp),
      expression: "canHelp"
    }],
    attrs: {
      "type": "checkbox",
      "id": "canHelp",
      "name": "canHelp"
    },
    domProps: {
      "checked": Array.isArray(_vm.canHelp) ? _vm._i(_vm.canHelp, null) > -1 : (_vm.canHelp)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.canHelp,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.canHelp = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.canHelp = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.canHelp = $$c
        }
      }
    }
  }), _c('label', {
    attrs: {
      "for": "canHelp"
    }
  }, [_vm._v("安全が確認でき次第、出社可能")])]), _c('div', {
    staticClass: "report"
  }, [_c('label', [_vm._v("報告事項（任意）")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    attrs: {
      "placeholder": "例）家族で○○小学校に避難中\n自宅前の道路は冠水のため走行不可等",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  })]), (_vm.sentAt) ? _c('p', {
    staticClass: "text-center text-sent-at"
  }, [_vm._v(_vm._s(_vm.sentAt) + "送信済み")]) : _vm._e()]), _c('div', {
    staticClass: "safety-confirmation-footer"
  }, [_c('div', {
    staticClass: "footer-content text-center"
  }, [_c('p', [_vm._v("安全確保を最優先に行動すること！")]), _c('button', {
    staticClass: "send-button",
    attrs: {
      "disabled": _vm.isExist ? false : 'disabled'
    },
    on: {
      "click": _vm.sendSafetyConfirmation
    }
  }, [_vm._v("送信する")]), (!_vm.isExist) ? _c('span', [_vm._v("現在は送信できません")]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-63156aa4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SafetyConfirmationEdit.vue
// module id = 1419
// module chunks = 1